<template>
  <div>
    <b-row>
      <b-col sm="12">
        <InputText title="Nome" field="name" :formName="formName" :required="true" :maxLength="40"
          v-model="chartOfAccounts.name" :markFormDirty="false" />
      </b-col>
    </b-row>
    <b-row>
      <b-col sm="12">
        <div class="text-right">
          <Button _key="btnSaveChartOfAccounts" type="success" title="Salvar" :disabled="!isFormValid(formName)"
            classIcon="fas fa-save" size="medium" :clicked="saveChartOfAccounts" />
        </div>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import InputText from "@/ui/forms/InputText";
import Button from "@/ui/forms/Button";

import ChartOfAccounts from "../../models/ChartOfAccounts";
import ChartOfAccountsService from "../../services/chartOfAccounts.service";

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "ChartOfAccountsCreateUpdate",
  props: {
    costCenterId: String,
    registerInSelect: Boolean,
    value: Object,
  },
  components: { InputText, Button },
  data() {
    return {
      formName: "chartOfAccountsCreateUpdate",
      chartOfAccounts: new ChartOfAccounts(),
    };
  },
  computed: {
    ...mapGetters("validation", ["isFormValid"]),
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapMutations("generic", [
      "addEvent",
      "removeLoading",
      "removeEvent",
      "hideModal",
      "hideVodal",
    ]),
    ...mapMutations("validation", ["resetValidation"]),
    async saveChartOfAccounts() {
      if (this.chartOfAccounts.id) {
        const response = await ChartOfAccountsService.update(this.chartOfAccounts);
        if (response.success && !this.registerInSelect) this.hideModal();
        this.addEvent({
          name: "chartOfAccountsSaved",
          data: this.chartOfAccounts,
        });
        this.removeLoading(["btnSaveChartOfAccounts"]);
        return;
      }

      this.chartOfAccounts.costCenterId = this.costCenterId;
      const response = await ChartOfAccountsService.create(this.chartOfAccounts);
      if (response.success && !this.registerInSelect) this.hideModal();
      if (response.success && this.registerInSelect) {
        this.$emit("input", {
          id: response.content.id,
          content: response.content.name,
        });
        this.hideVodal(this.formName);
      }
      this.addEvent({
        name: "chartOfAccountsSaved",
        data: this.chartOfAccounts,
      });
      this.removeLoading(["btnSaveChartOfAccounts"]);
    },
    update(data) {
      this.chartOfAccounts = new ChartOfAccounts();
      this.chartOfAccounts.update(data);
      this.removeLoading([data.id]);
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "chartOfAccountsCreate") {
          this.resetValidation(this.formName);
          this.chartOfAccounts = new ChartOfAccounts();
        }
        if (event.name == "chartOfAccountsUpdate") this.update(event.data);
      },
      deep: true,
    },
  },
};
</script>
